import apiService from './api.service'

/**
 * Testa o critério personalizado da remessa financeira sem gravar (PHOENIX-943).
 * Responde 200 com { valido, mensagem, totalContratos } mesmo quando o critério é recusado.
 */
const validarCriterioRemessa = (oidUnidade, consultaSql) => {
  return apiService.post('/lottustech/crud-integracao/validarCriterio', { oidUnidade, consultaSql })
}

export { validarCriterioRemessa }
